import { Component } from '@angular/core';
import { ApiService } from 'src/app/Services/Api/api.service';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css'],
})
export class ContactoComponent {
  constructor(private _apiService: ApiService) {
    this._apiService.get('contacto').then((data) => {
      this.cardsContactos = [
        {
          line: 'v-line',
          title1: 'Presencial',
          contacts: data.contactos
            .filter((contacto: any) => contacto.tipoContacto === '2')
            .map((contacto: any) => contacto.valor),
        },
        {
          line: 'v-line',
          title1: 'Teléfonos',
          contacts: data.contactos
            .filter((contacto: any) => contacto.tipoContacto === '0')
            .map((contacto: any) => contacto.valor),
        },
        {
          line: null,
          title1: 'Correos',
          contacts: data.contactos
            .filter((contacto: any) => contacto.tipoContacto === '1')
            .map((contacto: any) => contacto.valor),
        },
      ];
    });
  }

  BanerFirstTab = {
    title: 'Contáctanos',
    class1: 'white-bold-font mt-4',
    title2:
      'Estamos disponibles para brindarte el mejor servicio y ayudarte a solucionar todas tus inquietudes',
    class2: 'white text-info',
    dataTitle2: '',
    additionalTittle: '',
    additionalData: '',
  };
  imgFirstTab = {
    class: 'img-banner',
    src: 'https://via.placeholder.com/350',
    target: '_blank',
    targetURL: '',
    altT: '',
    heightInput: '',
    widthInput: '',
  };

  imgSrc: string = 'https://via.placeholder.com/350';
  altText: string = '';
  heightI: string = '';
  widthI: string = '';
  class: string = 'img-banner';

  dataHeader = {
    classTitle: 'blue negrilla',
    class1: 'text-center',
    title: 'Nuestros Canales',
  };

  cardsContactos: any[] = [];

  Correo = {
    title: 'Envíanos un correo',
    class1: 'blue-bold',
    title2:
      'Ponemos a tu dispocición este formulario para que puedas comunicarte con nosotros y nos permitas ayudarte con tus dudas o necesidades',
    selector: 'not',
  };

  Recursos = {
    title: 'Recursos PQRS',
    class1: 'blue-bold',
    title2:
      'La Concesión Autovía Neiva - Girardot pone a tu disposición un canal para que registres tus peticiones, quejas, reclamos y sugerencias.',
  };
}
